import ApiUtils from '@/utils/api/ApiUtils'
import ObjArrUtils from '@/utils/ObjArrUtils'
import _module from '@/store/base/module'

const module = {
  state: {
    formDialog: false,
    mode: 'PO' // [PO,public]
  },
  getters: {
    getFormDialog: state => state.formDialog,
    getMode: state => state.mode
  },
  mutations: {
    SET_FORM_DIALOG (state, val) { state.formDialog = val },
    SET_MODE (state, val) { state.mode = val }
  },
  actions: {
    async doAdd ({ state }) {
      const res = await ApiUtils.postData({
        data: [
          {
            api: 'C0401ProjectUpdateService.doAdd',
            input: state.row
          }
        ]
      })
      return res
    },
    async doEdit ({ commit, state }) {
      await ApiUtils.postData({
        data: [{ api: 'C0401ProjectUpdateService.doEdit', input: state.row }]
      })
    },
    async doRead ({ commit, state }) {
      const res = await ApiUtils.postData({
        data: [{ api: 'C0401ProjectUpdateService.doRead', input: { id: state.row.id } }]
      })
      commit('SET_ROW', res[0].output)
    },
    async doDelete ({ commit, state }) {
      await ApiUtils.postData({
        data: [{
          api: 'C0401ProjectUpdateService.doDelete',
          input: { id: state.row.id }
        }]
      })
    },
    async doBrowse ({ commit, state }) {
      const res = await ApiUtils.postData({
        data: [
          {
            api: 'C0401ProjectUpdateService.doBrowse',
            input: {
              pagination: state.pagination,
              searchInfo: state.searchInfo
            }
          }
        ]
      })
      if (state.pagination.current_page > 1) {
        state.rows = [...state.rows, ...res[0].output.data]
      } else {
        state.rows = res[0].output.data
      }
      state.pagination = res[0].output.pagination
    }
  }
}

export default ObjArrUtils.merge(_module, module)
